import { useHandleSignInCallback } from '@logto/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Callback = () => {
  const navigate = useNavigate();
  const { isLoading } = useHandleSignInCallback(() => {
    // 登录成功后重定向到首页
    navigate('/');
  });

  // 处理中显示加载状态
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
          <p className="text-gray-600">正在处理登录...</p>
        </div>
      </div>
    );
  }

  return null;
};

export default Callback;
